module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top'), _vm._v(" "), _c('main', [_c('container', [_c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('iframe', {
    attrs: {
      "src": "https://library-spyc-edu-hk.tonyhhyip.me/WebOPAC.exe"
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f8aa2150!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Home.vue
// module id = 83
// module chunks = 0